export default __webpack_public_path__ + "static/media/message.32fdd9a5.svg";